import { ReactNode, useCallback, useContext } from "react";
import { PopupContext, PopupOptions, PopupType } from "src/contexts/popup-context-types";

type Message = ReactNode | string | null

export const usePopup = () => {
  const context = useContext(PopupContext);

  if (!context) throw new Error('PopupContext must be used inside PopupProvider');
  const { setPopup: _setPopup } = context;

  const setPopup = useCallback((type: PopupType, message: Message, options?: PopupOptions) => {
    _setPopup({type, message, ...options})
  }, [_setPopup]);

  const setError = useCallback((message: Message, options?: PopupOptions) => {
    setPopup(PopupType.ERROR, message, options)
  }, [setPopup]);

  const setInfo = useCallback((message: Message, options?: PopupOptions) => {
    setPopup(PopupType.INFO, message, options)
  }, [setPopup]);

  const setWarning = useCallback((message: Message, options?: PopupOptions) => {
    setPopup(PopupType.WARNING, message, options)
  }, [setPopup]);

  const setSuccess = useCallback((message: Message, options?: PopupOptions) => {
    setPopup(PopupType.SUCCESS, message, options)
  }, [setPopup]);

  return {
    setError,
    setInfo,
    setWarning,
    setSuccess,
  };
};
